import { TextField } from 'material-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';


const IdentificationCard = ({ setChangedIdentification, identification, setIdentification }) => (

  <div style={{ marginTop: 14 }}>
    <TextField
      type="text"
      floatingLabelText={<FormattedMessage id="profile.accessCard" />}
      value={identification}
      onChange={(ev) => {
            setChangedIdentification(true);
            setIdentification(ev.target.value);
        }}
      fullWidth
      id="identification"
    />

  </div>

);
IdentificationCard.propTypes = {
  setChangedIdentification: PropTypes.func,
  identification: PropTypes.string,
  setIdentification: PropTypes.func,
};

export default IdentificationCard;



// WEBPACK FOOTER //
// ./src/components/profile/IdentificationCard.js